import React from 'react';
import { Box } from '@usealloy/component-library';
import styled from 'styled-components';
import { AiSummaryCard } from '~/application-review/AiSummaryCard/AiSummaryCard';

interface ContainerProps {
  evaluationToken: string;
  entityToken: string;
  workflowToken: string;
  workflowVersion: number;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--cl-space-5);
  align-items: start;
  width: 100%;
`;

const StyledCol = styled(Box)`
  && {
    min-width: 0;
  }
`;

export const Container: React.FC<ContainerProps> = ({
  evaluationToken,
  entityToken,
  workflowToken,
  workflowVersion,
  children,
  ...rest
}) => (
  <Box
    className="evaluation-detail"
    direction="column"
    gap={5}
    {...rest}
  >
    <AiSummaryCard
      token={evaluationToken}
      entityToken={entityToken}
      workflowToken={workflowToken}
      workflowVersion={workflowVersion}
    />
    {children}
  </Box>
);

export const Row: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <StyledGrid>
    {children}
  </StyledGrid>
);

export const Col: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <StyledCol
    direction="column"
    gap={5}
    alignItems="flex-start"
  >
    {children}
  </StyledCol>
);
